import { Navigate } from 'react-router-dom';
import { Storage } from 'enums';

interface PublicRouteProps {
  children: React.ReactNode;
}

export const PublicRoute: React.FC<PublicRouteProps> = ({ children }) => {
  const isAuthenticated = localStorage.getItem(Storage.ADMIN_TOKEN);

  if (isAuthenticated) {
    // Redirect authenticated users to admin dashboard
    return <Navigate to="/admin" replace />;
  }

  return <>{children}</>;
};
